// category-tree.component.ts
import { Component, Input } from '@angular/core';
//import { HttpClient } from '@angular/common/http';
import { Category } from '../models/category-model';
import { CategoryService } from '../services/category.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-category-tree',
  templateUrl: './category-tree.component.html'
})
export class CategoryTreeComponent {
  @Input() categories: Category[] = [];

  newCategoryName: { [key: number]: string } = {};
  showAddForm: { [key: number]: boolean } = {};

  constructor(private categoryService: CategoryService
    , private router: Router) { }

  toggleExpand(category: Category) {
    (category as any).expanded = !(category as any).expanded;
  }

  toggleAddForm(categoryId: number) {
    this.showAddForm[categoryId] = !this.showAddForm[categoryId];
  }

  addSubcategory(parentId: number) {
    const name = this.newCategoryName[parentId]?.trim();
    if (!name) return;

    const payload = {
      name,
      parentId,
      isActive: true,
      displayOrder: 0
    };

    this.categoryService.createCategory(payload).subscribe({
      next: (created) => {
        const parent = this.findCategory(this.categories, parentId);
        if (parent) {
          parent.children = parent.children || [];
          parent.children.push(created);
          (parent as any).expanded = true;
        }
        this.newCategoryName[parentId] = '';
        this.showAddForm[parentId] = false;
      },
      error: (err) => console.error('Failed to add subcategory', err)
    });
  }

  private findCategory(categories: Category[], id: number): Category | null {
    for (const cat of categories) {
      if (cat.id === id) return cat;
      if (cat.children) {
        const found = this.findCategory(cat.children, id);
        if (found) return found;
      }
    }
    return null;
  }

  addProduct(categoryId: number) {
    this.router.navigate(['/products/add'], {
      queryParams: { categoryId }
    });
  }
}
